import { AssetTypeItem } from '../../types/fundScreener.type';

// Placeholder shown before useFundAssetTypes fetches the real list.
export const DEFAULT_ASSET_TYPES: AssetTypeItem[] = [
  { value: 'ALL', label: 'All', activated: true },
];